import { useCallback } from 'react';
import { Trans } from '@frontend/i18n';
import { currency, Text } from '@frontend/design-system';
import { useCareCreditTranslations } from '../../../hooks/use-care-credit-translations';
import { EnrollmentBaseStep } from '../atoms/step/enrollment-base-step';
import { EnrollmentStepPerformanceWrapper } from '../atoms/step/enrollment-step-performance-wrapper';
import { useCareCreditEnrollmentContext } from '../context/care-credit-enrollment.context';
import { CareCreditEnrollmentMultiSteps } from '../enrollment-multi-step.types';

const CURRENT_STEP: CareCreditEnrollmentMultiSteps = 'applicant-pre-qualified-confirm';
const NEXT_STEP: CareCreditEnrollmentMultiSteps = 'application-details-submit';

export const Step3ApplicantPrequalified = () => {
  return (
    <EnrollmentStepPerformanceWrapper step={CURRENT_STEP}>
      <Step3ApplicantPrequalifiedBody />
    </EnrollmentStepPerformanceWrapper>
  );
};

const Step3ApplicantPrequalifiedBody = () => {
  const { t } = useCareCreditTranslations();

  const {
    multiStep: { goNextStep },
    onGoBack,
    applicationResult,
  } = useCareCreditEnrollmentContext();

  const amount = applicationResult?.plccOfferInfo?.creditLine || 0;

  const onClickConfirm = useCallback(() => {
    goNextStep({ orStep: NEXT_STEP });
  }, [goNextStep]);

  const onClickCancel = useCallback(() => {
    onGoBack();
  }, [onGoBack]);

  return (
    <EnrollmentBaseStep
      id={CURRENT_STEP}
      label={t('Applicant Prequalified')}
      isValid={true}
      header={{
        showCancelAction: true,
      }}
      footer={{
        primary: {
          children: t('Customer Accepts'),
        },
        onClickPrimary: onClickConfirm,
        secondary: {
          children: t('Cancel Application'),
        },
        onClickSecondary: onClickCancel,
        back: null,
      }}
    >
      <Text>
        <Trans
          t={t}
          i18nKey={`The applicant is prequalified with a <b>{{ amount }} credit limit.</b>`}
          values={{ amount: currency(amount || 0, { decimals: 0 }) }}
          components={{ b: <b /> }}
        />
      </Text>
      <br />
      <Text>
        <Trans t={t}>
          Ask the patient/client if they would like to accept this offer of credit and submit a full credit application,
          which includes a hard inquiry on their credit report.
          <br />
          <br />
          If the customer chooses not to accept and apply now, you will need to restart the prequalification later if
          they change their mind.
        </Trans>
      </Text>
    </EnrollmentBaseStep>
  );
};
